import React, { useState, useEffect } from "react";
import Slider from "react-slick";
import Heading from "../Heading";

function Repositories() {
  const [repos, setRepos] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const [slidesToShow, setSlidesToShow] = useState(3);

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth < 1000) {
        setSlidesToShow(1);
      } else {
        setSlidesToShow(4);
      }
    };

    window.addEventListener("resize", handleResize);
    handleResize(); // Set initial value based on current window size

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  var settings = {
    dots: false,
    infinite: true,
    autoplay: true,
    speed: 150,
    slidesToShow: slidesToShow,
    slidesToScroll: 2,
    mobileFirst: true,
  };

  useEffect(() => {
    const fetchRepos = async () => {
      try {
        const response = await fetch(
          "https://api.github.com/users/anmolkumarshah/repos"
        );
        if (!response.ok) {
          throw new Error(`Error: ${response.status} ${response.statusText}`);
        }
        const data = await response.json();
        // Sort repositories by last updated date in descending order
        const sortedData = data.sort(
          (a, b) => new Date(b.updated_at) - new Date(a.updated_at)
        );
        setRepos(sortedData);
      } catch (error) {
        setError(error.message);
      } finally {
        setLoading(false);
      }
    };

    fetchRepos();
  }, []);

  if (loading) return <div className="text-center mt-10">Loading...</div>;
  if (error)
    return <div className="text-center mt-10 text-red-500">Error: {error}</div>;

  return (
    <div className="mx-3 md:mx-20">
      <Heading
        id="work"
        text={"Works"}
        showRight={
          <a href="https://github.com/anmolkumarshah">Check All Repositories</a>
        }
      />
      <Slider {...settings} arrows={false}>
        {repos.map((repo, idx) => (
          <div className="mx-2" key={repo.id}>
            <div className="mx-2 p-4 bg-white rounded-lg border border-black shadow-md w-64 cursor-pointer">
              <h2 className="text-sm font-bold mb-2">{repo.name}</h2>
              <p className="text-gray-600 text-xs">
                Last updated: {new Date(repo.updated_at).toLocaleDateString()}
              </p>
            </div>
          </div>
        ))}
      </Slider>
    </div>
  );
}

export default Repositories;
